export class NavigationService {

    getQuery(name: string) {
        const params = new URLSearchParams(window.location.search);
        const query = params.get(name);
        return query;
    }

    setQuery(name: string, value: string | undefined) {
        if (window.history.pushState) {
            let searchParams = new URLSearchParams(window.location.search);
            if (value !== undefined) {
                searchParams.set(name, value);
            }
            else 
            {
                searchParams.delete(name);
            }
            let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
            window.history.pushState({ path: newUrl }, '', newUrl);
        }
    }
}
